import { useQuery } from "react-query";

import api from "../../../api";

const profileService = async () => {
  const { data } = await api.get(`/profile/section`);
  return data;
};

export const useProfileSectionQuery = () => {
  const { data } = useQuery("profile-section", profileService);
  return data;
};

export const useProfileSectionQueryForContact = () => {
  return useQuery("profile-section", profileService);
};
